import { Theme } from "@mui/material/styles";
import { neutral } from "app/themes/colors";

export const getTableComponents = (sunoTheme: Theme) => ({
  MuiTable: {
    styleOverrides: {
      root: {
        boxShadow: "none",
      },
    },
  },
  MuiTableRow: {
    styleOverrides: {
      head: {
        whiteSpace: "nowrap",
        boxShadow: "none",
      },
      root: {
        boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.1)",
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      head: {
        paddingTop: sunoTheme.spacing(1),
        paddingBottom: sunoTheme.spacing(1),
        paddingLeft: sunoTheme.spacing(2),
        paddingRight: sunoTheme.spacing(2),
        color: neutral[700],
        backgroundColor: "#F1F1F1",
        fontWeight: 600,
        letterSpacing: "0.08rem",
        textTransform: "uppercase",
      },
      root: {
        borderBottom: "none",
      },
    },
  },
});
